<template>
  <div v-if="page.home" :class="`page page-dark hello hello-${firstVisitAnimation ? 'first-visit' : ''} hello-dark`">
    <div class="hello--logo">
      <div class="hello--logo-pic hello--logo-animated">
        <svg v-if="!isIE11" width="669" height="482" viewBox="0 0 669 482">
          <g transform="translate(-3742 2351)">
            <use xlink:href="#logo_dark_path0_fill" transform="translate(3742 -2351)" fill="transparent"/>
            <use xlink:href="#logo_dark_path1_fill" transform="translate(3747 -2345)" fill="#5188fd"/>
          </g>
          <defs>
            <path id="logo_dark_path0_fill" d="M 0 0L 669 0L 669 482L 0 482L 0 0Z"/>
            <path id="logo_dark_path1_fill" d="M 599.049 121.918L 476.799 0L 241.159 0L 417.625 176.042L 544.752 176.042L 653.318 176.042L 599.049 121.918ZM 119.428 234.646L 259.881 72.924L 267.777 63.893L 266.848 62.827L 222.698 18.809L 203.851 0L 140.516 72.924L 0 234.646L 139.488 395.195L 203.324 468.661L 222.697 449.319L 267.302 404.822L 258.959 395.195L 119.428 234.646ZM 544.779 293.33L 417.599 293.33L 241.159 469.373L 476.771 469.373L 599.021 347.454L 653.283 293.33L 544.779 293.33Z"/>
          </defs>
        </svg>
        <img v-else src="/static/masks/logo-dark.png"/>
      </div>
    </div>

    <div class="hello--name">
      <h1><TextAnimation :word="page.home.title" :delay="600" :speed="80"/></h1>
      <div :class="`lead lead-${animation ? 'animated' : ''}`">
        <p v-html="page.home.text_lead_dark"/>
        <p class="sotbi-animation" v-html="page.home.text_lead_modern"/>
      </div>
    </div>

    <div :class="`hello--stat hello--stat-${animation ? 'animated' : ''} font-grotesque`">
      <div class="container hello--stat-wrap">
        <div v-for="num, key in statistic()" :class="`col-md-3 col-xs-6 hello--stat-col hello--stat-col-${animation ? 'animated' : ''}`" :style="`transition-delay: ${(key / 5)}s`">
          <div class="hello--stat-description small" v-html="page.home[`text_before_numbers_dark_0${key+1}`]" v-if="page.home[`text_before_numbers_dark_0${key+1}`]"></div>
          <h3 :ref="`desc_${key}`" >
            <TextPercentAnimation :delay="4000" :speed="1200" :word="page.home[num]"/>
          </h3>
          <div v-html="page.home[`text_numbers_desc_dark_0${key+1}`]"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import TextPercentAnimation from '@/components/TextPercentAnimation';
import TextAnimation from '@/components/TextAnimation';

import IEDetector from '@/mixins/IEDetector';

export default {
  mixins: [IEDetector],

  components: {
    TextPercentAnimation,
    TextAnimation,
  },

  computed: mapGetters({
    firstVisitAnimation: 'firstVisitAnimation',
    animation: 'animation',
    page: 'page',
  }),

  methods: {
    statistic() {
      const stat = Object.keys(this.page.home).filter(key => key.indexOf('text_numbers_dark_0') > -1);
      return stat;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello{
  &-first-visit{
    .hello--name,
    .hello--stat{
      opacity: 0;  
    }
  }
  &-dark{
    min-height: 100%;
  }
  &,
  &--logo,
  &--logo-pic,
  &--name{
    background: transparent;

    &:before,
    &:after{
      display: none;
    }
  }

  &--logo{
    position: relative;
    opacity: .3;
  }

  &--name{
    color: white;
  }
  &--stat{
    background: none;
    color: white;

    &-col{
      .hello--stat-description{
        transition: all .3s ease-in-out;
        position: absolute;
        opacity: 0;
        left: 20px;
        top: 35px;

        @media (max-width: $mediaIpad) {
          top: 0;
        }

        @media(max-width: $mediaLaptop) {
          left: 17px;
        }
      }
      &:hover .hello--stat-description{
        opacity: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/HomeDark.vue